var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useOutletContext, useParams } from "react-router-dom";
import { Button, Checkbox, Col, DatePicker, Form, Input, Row } from 'antd';
import { useLicense } from "@hooks";
import { errorMessage, getDateFormat, getLicenseApiUrl } from '@helpers';
import { Spinner } from "@components";
import { LinkOutlined } from '@ant-design/icons';
import { LicenseLogs } from "@pages";
import dayjs from 'dayjs';
export var License = function () {
    var _a;
    var apiData = useOutletContext();
    var _b = useState(false), isChanged = _b[0], setIsChanged = _b[1];
    var _c = useLicense((_a = apiData === null || apiData === void 0 ? void 0 : apiData.WAPI_TOKEN) !== null && _a !== void 0 ? _a : ''), license = _c.license, getLicense = _c.getLicense, updateLicense = _c.updateLicense, loading = _c.loading;
    var form = Form.useForm()[0];
    var id = useParams().id;
    useEffect(function () {
        if (id) {
            void getLicense(getLicenseApiUrl(id));
        }
    }, []);
    if (loading) {
        return _jsx(Spinner, {});
    }
    if (Object.keys(license).length === 0) {
        return _jsx("div", { children: "No license" });
    }
    var getDate = function (date) {
        var d = new Date(+date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    };
    var initialValues = {
        license: license.licenseKey,
        app: license.app,
        active: license.active,
        created: dayjs(getDate((Number(license.created) * 1000).toString()), getDateFormat()),
        expires: dayjs(getDate((Number(license.expires) * 1000).toString()), getDateFormat()),
        customer: license.customer,
        subscriptionID: license.subscriptionID,
        valid_domains: license.valid_domains,
        valid_IPs: license.valid_IPs
    };
    var formSubmitHandler = function (values) {
        updateLicense(values)
            .then(function () {
            var _a;
            void getLicense(process.env.LICENSE_URL + ((_a = values.license) !== null && _a !== void 0 ? _a : ''));
        })
            .catch(function (error) {
            errorMessage(error);
        });
        setIsChanged(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Update license" }), _jsxs(Form, __assign({ layout: 'vertical', className: 'custom-form', onValuesChange: function () { return setIsChanged(true); }, onFinish: formSubmitHandler, form: form, initialValues: initialValues }, { children: [_jsxs(Row, __assign({ justify: 'space-between' }, { children: [_jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'license', label: 'License:' }, { children: _jsx(Input, { readOnly: true }) })) })), _jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'app', label: 'App:' }, { children: _jsx(Input, {}) })) }))] })), _jsx(Row, { children: _jsx(Form.Item, __assign({ name: 'active', valuePropName: 'checked' }, { children: _jsx(Checkbox, { children: "Active" }) })) }), _jsxs(Row, __assign({ justify: 'space-between' }, { children: [_jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'created', label: 'Created:' }, { children: _jsx(DatePicker, {}) })) })), _jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'expires', label: 'Expires:' }, { children: _jsx(DatePicker, {}) })) }))] })), _jsxs(Row, __assign({ justify: 'space-between' }, { children: [_jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'customer', label: _jsxs("span", { children: ["Customer:", _jsx("a", __assign({ target: '_blank', style: { marginLeft: '5px' }, href: "https://dashboard.stripe.com/customers/".concat(license.customer) }, { children: _jsx(LinkOutlined, {}) }))] }) }, { children: _jsx(Input, {}) })) })), _jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'subscriptionID', label: _jsxs("span", { children: ["Subscription:", _jsx("a", __assign({ target: '_blank', style: { marginLeft: '5px' }, href: "https://dashboard.stripe.com/subscriptions/".concat(license.subscriptionID) }, { children: _jsx(LinkOutlined, {}) }))] }) }, { children: _jsx(Input, {}) })) }))] })), _jsxs(Row, __assign({ justify: 'space-between' }, { children: [_jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'valid_domains', label: 'Valid domains:' }, { children: _jsx(Input.TextArea, {}) })) })), _jsx(Col, __assign({ span: 11 }, { children: _jsx(Form.Item, __assign({ name: 'valid_IPs', label: 'Valid IPs:' }, { children: _jsx(Input.TextArea, {}) })) }))] })), _jsx(Form.Item, { children: _jsx(Button, __assign({ disabled: !isChanged, type: 'primary', htmlType: 'submit' }, { children: "Submit" })) })] })), _jsx(LicenseLogs, {})] }));
};
